import { Mapping } from './valuemappingManager.types';

// * (UI) Defines methods that does NOT require a valueFrom value
export const VALUE_FROM_NOT_REQUIRED_METHODS: Readonly<string[]> = <const>[
	'Last Known Value',
];

// * (validation) List of valid methods
export const VALID_METHODS: string[] = ['Custom', 'Last Known Value'];

// * (validation) error metadata
export type ValidationErrorParams = { badIndexes: number[] };

export interface ValuemappingProfileFormShape {
	profileName: string;

	sensorTypes: string[];
	sensorIds: string[];

	mappings: Mapping[];
}

export enum ValueMappingOperators {
	EQ = '=',
	GT = '>',
	LT = '<',
	GTEQ = '>=',
	LTEQ = '<=',
}

export type ValueMappingOps = '=' | '>' | '<' | '>=' | '<=';
